import { useEffect } from 'react';
import { PATHS } from 'Libraries/routes.library';
import { useRouter } from 'next/router';

const Iframe = () => {
  const router = useRouter();

  useEffect(() => {
    if (
      window?.self !== window?.parent &&
      [
        PATHS.PNP_STATUS_SUCCESS as string,
        PATHS.PNP_STATUS_FAIL as string,
        PATHS.PNP_STATUS_CANCEL as string,
        PATHS.PNP_STATUS as string,
      ].includes(router.pathname) === false
    ) {
      window?.parent?.postMessage({
        homepageInsideIframe: true,
      });
    }
  }, []);

  return <></>;
};

export default Iframe;
